import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setFilter } from '../../store/slices/animeDB.slice.js'
import { SearchBar } from './SearchBar.jsx'
import { AnimePreview } from './AnimePreview.jsx'

export function AnimeList({ animes, statusMap }) {
  const dispatch = useDispatch()
  const { filterBy } = useSelector((state) => state.animeDB)

  function onSetFilter(changes) {
    dispatch(setFilter({ ...changes, page: 1 }))
  }

  return (
    <div>
      <SearchBar filterBy={filterBy} onSetFilter={onSetFilter} />

      <ul className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 gap-4 mt-4">
        {animes.map((anime) => (
          <AnimePreview
            key={anime.mal_id}
            anime={anime}
            status={statusMap[anime.mal_id]}
          />
        ))}
      </ul>
    </div>
  )
}
